export const storage = {
    getToken: () => {
        return localStorage.getItem('accessToken');
    },
    setToken: (token) => {
        localStorage.setItem('accessToken', token);
    },
    removeToken: () => {
        localStorage.removeItem('accessToken');
    },
    getEmail: () => {
        return localStorage.getItem('userEmail');
    },
    setEmail: (email) => {
        localStorage.setItem('userEmail', email);
    },
    getRememberMe: () => {
        return localStorage.getItem('rememberMe') === 'true';
    },
    setRememberMe: (remember) => {
        localStorage.setItem('rememberMe', remember.toString());
    },
    // Original account management (for "View Portal" feature)
    setOriginalAccount: (token, user) => {
        localStorage.setItem('originalToken', token);
        localStorage.setItem('originalUser', user);
    },
    getOriginalAccount: () => {
        const token = localStorage.getItem('originalToken');
        const user = localStorage.getItem('originalUser');
        if (token && user) {
            return { token, user };
        }
        return null;
    },
    clearOriginalAccount: () => {
        localStorage.removeItem('originalToken');
        localStorage.removeItem('originalUser');
    },
    hasOriginalAccount: () => {
        return !!localStorage.getItem('originalToken');
    },
    clear: () => {
        localStorage.clear();
    },
};
